import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { Controller } from '../../../../core';
const SECRET_PROPERTY_NAME = 'raw';
export const Secret = (props) => {
    var _a;
    const { spec, name, input, Layout } = props;
    const childSpec = React.useMemo(() => {
        var _a, _b;
        if ((_a = spec.properties) === null || _a === void 0 ? void 0 : _a[SECRET_PROPERTY_NAME]) {
            const childSpec = cloneDeep((_b = spec.properties) === null || _b === void 0 ? void 0 : _b[SECRET_PROPERTY_NAME]);
            childSpec.viewSpec.layout = 'transparent';
            return childSpec;
        }
        return undefined;
    }, [spec.properties]);
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => input.onChange((currentValue) => set(Object.assign({}, currentValue), childName.split(`${input.name}.`).join(''), childValue), childErrors), [input.onChange, input.name]);
    if (!childSpec) {
        return null;
    }
    const content = (React.createElement(Controller, { value: (_a = input.value) === null || _a === void 0 ? void 0 : _a[SECRET_PROPERTY_NAME], spec: childSpec, name: `${name}.${SECRET_PROPERTY_NAME}`, parentOnChange: parentOnChange, parentOnUnmount: input.parentOnUnmount, key: `${name}.${SECRET_PROPERTY_NAME}` }));
    if (Layout) {
        return React.createElement(Layout, Object.assign({}, props), content);
    }
    return React.createElement(React.Fragment, null, content);
};
